export type GetIfDefinitionCommonValidationResultRequest = {
  dfnSetVerNum: string;
  validationTypeCode: string;
  pjtId: string;
};
